// extracted by mini-css-extract-plugin
module.exports = {"posts":"Haberler-module--posts--3Mwa-"};